import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { Box, Grid, TAGTypography, Avatar, TAGButton, useTheme, useMediaQuery, TAGDialog, TAGDialogActions, TAGPhoneDrawer } from '../../..';
import DoctorInfo from './DoctorInfo';

var Doctors = function Doctors(_ref) {
  var _state$active, _state$active2, _state$active3, _state$active4, _state$active5, _state$active6, _state$active7, _state$active8, _state$active9, _state$active10, _state$active11, _state$active12, _state$active13, _state$active14, _state$active15, _state$active16, _state$active17;

  var doctors = _ref.doctors;
  var theme = useTheme();
  var isSmall = useMediaQuery(theme.breakpoints.down('md'));
  var endIndex = isSmall ? 5 : 9;

  var _useState = useState({
    active: null,
    display: false,
    doctorsList: [],
    displayShowMoreButton: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      doctorsList: doctors.slice(0, endIndex),
      displayShowMoreButton: doctors.length > endIndex
    }));
  }, [isSmall]);

  var showModal = function showModal(act) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      active: act,
      display: true
    }));
  };

  var handleShowMoreClick = function handleShowMoreClick() {
    var newList = state.doctorsList.concat(doctors.slice(state.doctorsList.length, state.doctorsList.length + endIndex));
    setState(_objectSpread(_objectSpread({}, state), {}, {
      doctorsList: newList,
      displayShowMoreButton: newList.length < doctors.length
    }));
  };

  var showAvatar = doctors.find(function (doctor) {
    return doctor.image;
  });
  var DoctorInfoProps = {
    setState: setState,
    state: state,
    image: state === null || state === void 0 ? void 0 : (_state$active = state.active) === null || _state$active === void 0 ? void 0 : _state$active.image,
    firstName: state === null || state === void 0 ? void 0 : (_state$active2 = state.active) === null || _state$active2 === void 0 ? void 0 : _state$active2.firstName,
    lastName: state === null || state === void 0 ? void 0 : (_state$active3 = state.active) === null || _state$active3 === void 0 ? void 0 : _state$active3.lastName,
    degree: state === null || state === void 0 ? void 0 : (_state$active4 = state.active) === null || _state$active4 === void 0 ? void 0 : _state$active4.degreeName,
    providerType: (state === null || state === void 0 ? void 0 : (_state$active5 = state.active) === null || _state$active5 === void 0 ? void 0 : _state$active5.providerType) || (state === null || state === void 0 ? void 0 : (_state$active6 = state.active) === null || _state$active6 === void 0 ? void 0 : _state$active6.jobTitle),
    gender: state === null || state === void 0 ? void 0 : (_state$active7 = state.active) === null || _state$active7 === void 0 ? void 0 : _state$active7.gender,
    bio: state === null || state === void 0 ? void 0 : (_state$active8 = state.active) === null || _state$active8 === void 0 ? void 0 : _state$active8.biography,
    location: state === null || state === void 0 ? void 0 : (_state$active9 = state.active) === null || _state$active9 === void 0 ? void 0 : _state$active9.location,
    graduationDate: state === null || state === void 0 ? void 0 : (_state$active10 = state.active) === null || _state$active10 === void 0 ? void 0 : _state$active10.graduationDate,
    dentalEducation: state === null || state === void 0 ? void 0 : (_state$active11 = state.active) === null || _state$active11 === void 0 ? void 0 : _state$active11.collegeName,
    collegeCityState: "".concat(state === null || state === void 0 ? void 0 : (_state$active12 = state.active) === null || _state$active12 === void 0 ? void 0 : _state$active12.collegeCity, ", ").concat(state === null || state === void 0 ? void 0 : (_state$active13 = state.active) === null || _state$active13 === void 0 ? void 0 : _state$active13.collegeState),
    dentalSpecialties: state === null || state === void 0 ? void 0 : (_state$active14 = state.active) === null || _state$active14 === void 0 ? void 0 : _state$active14.specialties,
    hireDate: state === null || state === void 0 ? void 0 : (_state$active15 = state.active) === null || _state$active15 === void 0 ? void 0 : _state$active15.hireDate,
    languages: state === null || state === void 0 ? void 0 : (_state$active16 = state.active) === null || _state$active16 === void 0 ? void 0 : _state$active16.languages,
    facilities: state === null || state === void 0 ? void 0 : (_state$active17 = state.active) === null || _state$active17 === void 0 ? void 0 : _state$active17.childrenFacility,
    isSmall: isSmall
  };
  return React.createElement(Box, null, React.createElement(Grid, {
    container: true,
    rowSpacing: {
      xs: 5,
      md: 7.5
    },
    columnSpacing: {
      xs: 0,
      md: 5
    },
    justifyContent: "center",
    alignItems: "center"
  }, state.doctorsList.map(function (doctor) {
    var _doctor$image, _doctor$image$file;

    var name = "".concat(doctor.firstName, " ").concat(doctor.lastName);
    var degree = doctor.degreeName;
    var providerType = doctor.jobTitle;
    var education = doctor.collegeName;
    var image = ((_doctor$image = doctor.image) === null || _doctor$image === void 0 ? void 0 : (_doctor$image$file = _doctor$image.file) === null || _doctor$image$file === void 0 ? void 0 : _doctor$image$file.url) || doctor.image;
    return React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 4,
      key: doctor.npi,
      onClick: function onClick() {
        return showModal(doctor);
      },
      sx: {
        transition: 'opacity .3s ease',
        cursor: 'pointer',
        '&:hover': {
          opacity: '.7'
        }
      }
    }, React.createElement(Grid, {
      container: true,
      alignItems: "center",
      wrap: "nowrap"
    }, showAvatar && React.createElement(Grid, {
      item: true,
      sx: {
        mr: '16px'
      }
    }, React.createElement(Avatar, {
      src: image,
      alt: name,
      sx: {
        width: {
          xs: '64px',
          md: '80px'
        },
        height: {
          xs: '64px',
          md: '80px'
        }
      }
    })), React.createElement(Grid, {
      item: true,
      sx: {
        flex: 1,
        textAlign: {
          xs: 'left',
          md: showAvatar ? 'left' : 'center'
        }
      }
    }, React.createElement(TAGTypography, {
      variant: "bodyLargeBold",
      color: "text.primary",
      sx: {
        marginBottom: {
          xs: '0px',
          md: '4px'
        },
        display: 'block'
      }
    }, name, degree && ', ' + degree), React.createElement(TAGTypography, {
      variant: "overline",
      color: 'text.secondary',
      sx: {
        marginBottom: {
          xs: '0px',
          md: '4px'
        },
        display: 'block',
        textTransform: 'uppercase'
      }
    }, providerType), education && React.createElement(TAGTypography, {
      variant: isSmall ? 'lowestLevel' : 'captionMediumRegular',
      color: "text.tertiary",
      sx: {
        display: 'block'
      }
    }, education), doctor.location && React.createElement(TAGTypography, {
      variant: "bodySmallSemiBold",
      color: "text.tertiary"
    }, doctor.location))));
  }), state.displayShowMoreButton && React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGButton, {
    buttonVariant: "Tertiary Default",
    buttonIcon: "SortDown",
    buttonIconPosition: "end",
    onClick: handleShowMoreClick,
    buttonSize: "small"
  }, "Show more"))))), isSmall ? React.createElement(TAGPhoneDrawer, {
    open: state.display,
    onOpen: function onOpen() {
      return null;
    },
    onClose: function onClose() {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        display: false
      }));
    }
  }, React.createElement(DoctorInfo, _objectSpread({}, DoctorInfoProps))) : React.createElement(TAGDialog, {
    handleClose: function handleClose() {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        display: false,
        active: null
      }));
    },
    open: state.display,
    sx: {
      '.MuiGrid-container': {
        width: '100%'
      },
      '.MuiGrid-root': {
        position: 'static'
      },
      '.MuiPaper-root': {
        maxWidth: '620px',
        width: '100%'
      }
    }
  }, React.createElement(DoctorInfo, _objectSpread({}, DoctorInfoProps)), React.createElement(TAGDialogActions, {
    sx: {
      backgroundColor: 'backgrounds.neutral'
    }
  }, React.createElement(TAGButton, {
    buttonVariant: "Tertiary Default",
    onClick: function onClick() {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        display: false,
        active: null
      }));
    },
    buttonSize: "small"
  }, "Dismiss"))));
};

export default Doctors;